import styles from "./TermsAndConditions.module.css";

const DocTermsAndConditions = ({
  setOpenPopup,
  setTermsAndConditionCheck,
  setPreSurvey,
}) => {
  return (
    <div className={styles.termsContainer}>
      <header className={styles.termsHeader}>
        <h1>TERMS & CONDITIONS</h1>
        <p>Last Updated: 10-Jan-2025</p>
      </header>
      <section className={styles.intro}>
        <h1>Introduction & License Grant</h1>
        <p>
          By creating a professional account, you agree to these Terms &
          Conditions and our Privacy Policy (“Agreement”).
        </p>
        <p>
          We (the “Organization”) grant you a limited, non-exclusive license to
          use our specialized application (the “App”) and related materials to
          provide early intervention services to children with developmental
          delays.
        </p>
      </section>

      <section className={styles.section}>
        {/* <h2>Terms & Conditions for Pediatricians</h2> */}
        <h3>1. Use of the App & Obligations</h3>
        <ul>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              You will use the App only for identifying, assessing, and
              coordinating early intervention services for children under six.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              You agree to follow applicable laws and ethical standards,
              including obtaining informed consent from parents or legal
              guardians before collecting children’s data.
            </span>
          </li>
        </ul>

        <h3>2. Data Collection & Privacy</h3>
        <ul>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              All personal data you collect using the App belongs to the child’s
              parent/legal guardian.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              We store this data on secure servers and take reasonable measures
              to protect confidentiality.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              You agree that the Organization may use anonymized data for
              research and development purposes, including refining the App and
              related services.
            </span>
          </li>
        </ul>

        <h3>3. Intellectual Property & Improvements</h3>
        <ul>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              The Organization retains all rights, title, and interest in the
              App, including assessments, reports, and any third-party tools
              embedded in the App.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              If your usage leads to any App improvements, such improvements are
              owned by the Organization.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              You must not modify, reverse engineer, or otherwise exploit the
              App outside the scope of providing care to Participants.
            </span>
          </li>
        </ul>

        <h3>4. Confidentiality</h3>
        <ul>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              You may receive confidential information about the App or the
              Organization.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              You agree to protect such information and disclose it only to
              staff who need to use it for the Program.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              Upon request, or when you discontinue use, you will return or
              destroy any confidential materials.
            </span>
          </li>
        </ul>

        <h3>5. Limitations & Liability</h3>
        <ul>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              The App is a support tool; clinical decisions remain your
              responsibility as the pediatrician.
            </span>
          </li>
          <li className={styles.li}>
            {/* <span className={styles.termLabel}>Restrictions:</span>{" "} */}
            <span className={styles.termDescription}>
              Neither party is liable for indirect or incidental damages, except
              in cases of breach of confidentiality or intellectual property
              rights.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              This Agreement does not replace your professional duty of care.
            </span>
          </li>
        </ul>
        <h3>6. Term & Termination</h3>
        <ul>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              Your license to use the App lasts for the duration agreed upon
              with the Organization.
            </span>
          </li>
          <li className={styles.li}>
            {/* <span className={styles.termLabel}>Restrictions:</span>{" "} */}
            <span className={styles.termDescription}>
              We may terminate access if you breach these terms; upon
              termination, you must cease using the App.
            </span>
          </li>
          <li className={styles.li}>
            <span className={styles.termDescription}>
              Aggregated or anonymized data may be retained for research after
              termination.
            </span>
          </li>
        </ul>
      </section>

      <section className={styles.generalProvisions}>
        <h2>Acceptance</h2>
        <p>
          By checking the box or clicking “I Agree,” you acknowledge that you
          have read, understood, and consent to be bound by these Terms &
          Conditions and Privacy obligations.
        </p>
      </section>

      <footer className={styles.termsFooter}>
        <p>
          For any questions contact us at:{" "}
          <a href="mailto:support@smile2steps.com">support@smile2steps.com</a>
        </p>
      </footer>
      <div className={styles.termandconditionbtns}>
        <button
          onClick={() => {
            setOpenPopup(false);
            setPreSurvey(true);
          }}
        >
          I Agree
        </button>
        <button
          onClick={() => {
            setOpenPopup(false);
            setTermsAndConditionCheck(false);
          }}
        >
          Decline
        </button>
      </div>
    </div>
  );
};

export default DocTermsAndConditions;
